import { LevelType } from '../types/Level';
import { normalizeFinals, stripNiqqud } from './normalize';

export const HEBREW_LETTERS = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ', 'ק', 'ר', 'ש', 'ת'];
export const MAX_KEY_LETTERS = 16;

export interface KeyLetterResult {
  letters: string[];
  sourceCount: number;
  randomAdded: number;
  truncated: boolean;
}

// Every different letter of the answer, padded with random Hebrew letters up to 16.
export const generateKeyLetters = (sourceText: string, random: () => number = Math.random): KeyLetterResult => {
  const chars = normalizeFinals(stripNiqqud(sourceText).toUpperCase()).split('');
  const letters = Array.from(new Set(chars)).filter(
    letter => /[א-ת]/.test(letter) || /[A-Z]/.test(letter)
  );
  const sourceCount = letters.length;

  const available = HEBREW_LETTERS.filter(letter => letters.indexOf(letter) === -1);
  let randomAdded = 0;
  while (letters.length < MAX_KEY_LETTERS && available.length > 0) {
    const index = Math.floor(random() * available.length);
    letters.push(available.splice(index, 1)[0]);
    randomAdded++;
  }

  return {
    letters: letters.slice(0, MAX_KEY_LETTERS),
    sourceCount,
    randomAdded,
    truncated: sourceCount > MAX_KEY_LETTERS,
  };
};

// The text key letters are taken from, or null for types that have none.
export const keyLetterSource = (item: { levelType: LevelType; sentence?: string; words?: string[] }): string | null => {
  switch (item.levelType) {
    case LevelType.CategoryWords:
      return (item.words || []).join('');
    case LevelType.WordSearch:
      return null;
    default:
      return item.sentence || '';
  }
};
